<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.itemName"
              placeholder="请输入合同服务项目名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @del="delFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// API
import { loadContractServiceItemListDataApi, exportContractServiceItemListDataApi, deleteContractServiceItemApi } from '@/api/v2/contractServiceItem'

export default {
  name: 'ContractServiceItem',
  components: {
    CustomTable2,
    TableOperation2,
    addEditViewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'base_contract_service_item_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['contract_service_item_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['contract_service_item_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['contract_service_item_del'],
            prop: 'del',
            label: '作废',
            method: 'del'
          },
          {
            permissionSigns: ['contract_service_item_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['contract_service_item_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          itemName: ''
        }
      },
      id: null,
      eventType: '',
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'tcs.province_name', width: 120 },
      { prop: 'year', label: '年份', filterColumn: 'tcs.year', width: 80 },
      { prop: 'contractName', label: '合同名称', filterColumn: 'tcs.name', width: 200 },
      { prop: 'contractCode', label: '合同编号', filterColumn: 'tcs.code', width: 180 },
      { prop: 'sortValue', label: '类别', filterColumn: 'tcs.sort', filterValue: 'sort', filterArray: [{ label: '合同一(终端运维)', value: 1 }, { label: '合同二(品牌推广)', value: 2 }, { label: '委外服务合同', value: 3 }], width: 100 },
      { prop: 'typeValue', label: '类型', filterColumn: 'tcsi.type', filterValue: 'type', filterArray: [{ label: '终端运维', value: 1 }, { label: '人员服务', value: 2 }, { label: '宣传展示（服务类）', value: 3 }, { label: '宣传展示（制作类）', value: 4 }, { label: '色彩终端', value: 5 }, { label: '品系宣介', value: 6 }, { label: '其他费用', value: 7 }, { label: '场地租赁', value: 8 }], width: 140 },
      { prop: 'name', label: '项目名称', filterColumn: 'tcsi.name', width: 200 },
      { prop: 'unit', label: '单位', filterColumn: 'tcsi.unit', width: 80 },
      { prop: 'specification', label: '规格型号', filterColumn: 'tcsi.specification', width: 120 },
      { prop: 'price', label: '单价', filterColumn: 'tcsi.price', width: 100, formatPrice: true },
      { prop: 'taxRateValue', label: '税率', filterColumn: 'tcsi.tax_rate', filterValue: 'taxRate', width: 80 },
      { prop: 'taxInclusivePrice', label: '含税价格', filterColumn: 'tcsi.tax_inclusive_price', width: 120 },
      { prop: 'needSampleValue', label: '需要定样', filterColumn: 'tcsi.need_sample', filterValue: 'needSample', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 110 },
      { prop: 'performanceAssessValue', label: '绩效考核', filterColumn: 'tcsi.performance_assess', filterValue: 'performanceAssess', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 110 },
      { prop: 'isInOutDepotValue', label: '是否出入库管理', filterColumn: 'tcsi.is_in_out_depot', filterValue: 'isInOutDepot', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }], width: 150 },
      { prop: 'remark', label: '备注说明', filterColumn: 'tcsi.remark', width: 200 },
      { prop: 'operatorName', filterColumn: 'tcsi.operator_name', label: '操作人', width: 100 },
      { prop: 'operationTime', filterColumn: 'tcsi.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadContractServiceItemListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        this.handleData(data.list || []);
        _this.masterList.tableDataTotal = data.total || 0;
      }).catch()
    },
    // 新增
    addFun () {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditTitle = '新增合同服务项目'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 修改
    editFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditTitle = '修改合同服务项目'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditTitle = '查看合同服务项目'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 作废
    delFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该合同服务项目？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteContractServiceItemApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportContractServiceItemListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
